<template>
    <div>
            <form-loader v-if="loading" message="Opslaan..."/>

            <template v-if="!loading">
                <b-row>
                    <b-col sm="6">
                        <div  class="form-label">
                            <i class="fa fax fa-unlock-alt"></i>
                            <label for="password_new">Wachtwoord*</label>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <b-input-group>
                            <b-form-input
                                    type="password"
                                    :type="show_password_new  ? 'text' : 'password'"
                                    v-model="form.password_new"
                                    size="sm"
                                    placeholder=""
                                    @focus="activeInput = 'password'"
                                    @blur="activeInput = null"
                                    required
                            />
                            <password-eye @click="show_password_new = !show_password_new" :state="show_password_new"/>
                        </b-input-group>
                    </b-col>
                    <keep-alive>
                        <password-check-box
                                v-if="activeInput === 'password'"
                                :password="form.password_new"
                                :passwordConfirmation="form.password_repeat"
                        />
                    </keep-alive>
                </b-row>
                <b-row>
                    <b-col sm="6">
                        <div  class="form-label">
                            <i class="fa fax fa-unlock-alt"></i>
                            <label for="password_repeat">Wachtwoord bevestigen*</label>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <b-input-group>
                            <b-form-input
                                    type="password"
                                    :type="show_password_new  ? 'text' : 'password'"
                                    v-model="form.password_repeat"
                                    size="sm"
                                    placeholder=""
                                    @focus="activeInput = 'password'"
                                    @blur="activeInput = null"
                                    required
                            />
                            <password-eye @click="show_password_new = !show_password_new" :state="show_password_new"/>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row v-if="showPasswordError">
                    <b-col sm="12">
                        <b-alert variant="danger" dismissible :show="true">
                            Uw wachtwoord moet voldoen aan de volgende eisen:
                            <ul>
                                <li>Minimaal 8 tekens</li>
                                <li>Bevat minimaal 1 cijfer</li>
                                <li>Bevat minimaal 1 hoofdletter</li>
                                <li>Bevat minimaal 1 leesteken</li>
                                <li>Beide wachtwoorden moeten overeen komen</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-row>
                <error-box v-if="postErrors.length > 0" :errors="postErrors"/>

                <FormButtons @next="next" @previous="$emit('previous')"/>
            </template>
    </div>
</template>

<script>
    import FormButtons from '@/components/_registration/FormButtons'
    import PasswordCheckBox from '@/components/PasswordCheckBox'
    import { checkPassword } from '@/_helpers'
    import { accountService } from '@/_services'
    import ErrorBox from '@/components/_registration/ErrorBox'
    import FormLoader from '@/components/_registration/FormLoader'
    import PasswordEye from '@/components/PasswordEye'
    export default {
        components: { FormButtons, PasswordCheckBox, ErrorBox, FormLoader, PasswordEye },
        data: () => {
            return {
                title: 'Wachtwoord Aanpassen',
                content: '',
                show_password_new: false,
                successMessage: false,
                postErrors: false,
                loading: false,
                form: {
                    password_new: '',
                    password_repeat: '',
                },
                showPasswordError: false,
                activeInput: ''
            }
        },
        name: 'Privacy',
        mounted() {
            this.$emit('validated', true)
        },
        activated () {
            this.$bvModal.show('privacyModal')
        },
        methods: {
            next () {
                this.submit()
            },
            submit () {
                let validation = checkPassword(this.form.password_new, this.form.password_repeat)

                if (validation.valid_password) {
                    this.showPasswordError = false
                    this.loading = true
                    accountService.editPassword(this.form.password_new)
                        .then(result => {
                            if (typeof result === 'object' && result !== null && 'errors' in result) {
                                this.postErrors = result.errors
                            } else {
                                this.postErrors = []

                                this.successMessage = true
                                this.form.password_new = ''
                                this.form.password_repeat = ''
                                if(this.$store.state.registration.newUser !== undefined && this.$store.state.registration.newUser === true) {
                                  this.$emit('next')
                                } else {
                                  this.$emit('previous')
                                }
                            }
                        }).catch((error) => {
                        console.log(error)
                        alert('oops er is iets fout gegaan. Herlaad de pagina en probeer het opnieuw.')
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.showPasswordError = true
                }
            }
        }
    }
</script>

<style scoped>

</style>